import { render, staticRenderFns } from "./OneSchool.vue?vue&type=template&id=f651f1f6&scoped=true&"
import script from "./OneSchool.vue?vue&type=script&lang=js&"
export * from "./OneSchool.vue?vue&type=script&lang=js&"
import style0 from "./OneSchool.vue?vue&type=style&index=0&id=f651f1f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f651f1f6",
  null
  
)

export default component.exports